import { render, staticRenderFns } from "./AlleGerechten.vue?vue&type=template&id=b6bc5550&scoped=true&"
import script from "./AlleGerechten.vue?vue&type=script&lang=js&"
export * from "./AlleGerechten.vue?vue&type=script&lang=js&"
import style0 from "./AlleGerechten.vue?vue&type=style&index=0&id=b6bc5550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc5550",
  null
  
)

export default component.exports